/* globals firebase */

import React from 'react';
import { FormField } from '../form-field';

import serialize from 'form-serialize';
import { RichText } from '../rich-text';
import { Helmet } from 'react-helmet';

export class Form extends React.Component {
  constructor (props) {
    super(props);
    this.state = { isSent: false };
  }

  componentDidMount () {
    this.waitForFireBase();
  }

  waitForFireBase = () => {
    if (window.firebase && firebase.firestore) {
      this.firebaseLoaded();
    } else {
      setTimeout(this.waitForFireBase, 100);
    }
  }

  firebaseLoaded = () => {
    var firebaseConfig = {
      apiKey: "AIzaSyAMsBb3Dpz_F8SS3qQvRCp0HmUyEoE6Z78",
      authDomain: "europalia-d79dd.firebaseapp.com",
      databaseURL: "https://europalia-d79dd.firebaseio.com",
      projectId: "europalia-d79dd",
      storageBucket: "europalia-d79dd.appspot.com",
      messagingSenderId: "518983533376",
      appId: "1:518983533376:web:6e555c1b57b3ac24"
    };

    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    this.db = firebase.firestore();
  }

  submit = (e) => {
    e.preventDefault();
    var data = serialize(document.querySelector('form'), { hash: true });
    data.createdAt = firebase.firestore.FieldValue.serverTimestamp();
    var missingFields = this.props.fields.filter(field => field.isARequiredField).filter(field => !data[field.name]);
    if (missingFields.length === 0) {
      this.setState({ isSent: true, data });
      this.db.collection(this.props.id).add(data);
    } else {
      this.setState({ invalid: true, missingFields });
    }
  }

  render () {
    if (this.state.isSent) return this.renderSent();

    return (
      <div className="form__wrapper">
        <Helmet>
          <script src="https://www.gstatic.com/firebasejs/6.3.0/firebase-app.js" />
          <script src="https://www.gstatic.com/firebasejs/6.3.0/firebase-firestore.js" />
        </Helmet>
        
        <div className="form__intro typo-body">
          <RichText document={this.props.intro} />
        </div>
        <form className="form" onSubmit={this.submit}>
          { this.props.fields.map(field => <FormField field={field} />) }
          <input type="submit" value={this.props.button} className="button form__submit"/>
          { this.state.invalid && <div className="form__invalid">
            Missing fields: ({ this.state.missingFields.map(field => field.title).join(', ') })
          </div> }
        </form>
      </div>
    );
  }

  renderSent () {
    return (
      <div className="form__wrapper">
        <div className="form__intro form__thanks typo-body">
          <RichText document={this.props.thankYou} />
        </div>
      </div>
    )
  }
}
